const _userAgent = navigator.userAgent || navigator.vendor || window.opera;


const isAndroid = _userAgent.match(/Android/i);
const isIos = _userAgent.match(/(iPad|iPhone|iPod)/i);
const isMobile = isAndroid || isIos;


export {
  isAndroid,
  isIos,
  isMobile,
};
